// مؤثرات صوتية موحّدة عبر Web Audio (بدون ملفات خارجية) مع كتم يُحفظ محليًا
let muted = false;
try { muted = localStorage.getItem("cineart_muted") === "1"; } catch (e) {}

export const isMuted = () => muted;
export const setMuted = (v) => { muted = v; try { localStorage.setItem("cineart_muted", v ? "1" : "0"); } catch (e) {} };

function newCtx() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  const c = new AC();
  if (c.state === "suspended") c.resume();
  return c;
}

export function playOpen() {
  if (muted) return;
  try {
    const ctx = newCtx(); if (!ctx) return; const now = ctx.currentTime;
    const o1 = ctx.createOscillator(); o1.type = "sine";
    o1.frequency.setValueAtTime(196, now); o1.frequency.exponentialRampToValueAtTime(523, now + 1.1);
    const o2 = ctx.createOscillator(); o2.type = "triangle";
    o2.frequency.setValueAtTime(294, now); o2.frequency.exponentialRampToValueAtTime(784, now + 1.1);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, now); g.gain.exponentialRampToValueAtTime(0.1, now + 0.18); g.gain.exponentialRampToValueAtTime(0.0001, now + 1.6);
    o1.connect(g); o2.connect(g); g.connect(ctx.destination);
    o1.start(now); o2.start(now); o1.stop(now + 1.7); o2.stop(now + 1.7);
    setTimeout(() => ctx.close().catch(() => {}), 2000);
  } catch (e) {}
}

export function playShutter() {
  if (muted) return;
  try {
    const ctx = newCtx(); if (!ctx) return; const now = ctx.currentTime;
    const o = ctx.createOscillator(); o.type = "square";
    o.frequency.setValueAtTime(680, now); o.frequency.exponentialRampToValueAtTime(90, now + 0.2);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, now); g.gain.exponentialRampToValueAtTime(0.2, now + 0.015); g.gain.exponentialRampToValueAtTime(0.0001, now + 0.28);
    o.connect(g); g.connect(ctx.destination); o.start(now); o.stop(now + 0.3);
    setTimeout(() => ctx.close().catch(() => {}), 500);
  } catch (e) {}
}

let lastClick = 0;
export function playClick() {
  if (muted) return;
  const now = Date.now(); if (now - lastClick < 60) return; lastClick = now;
  try {
    const ctx = newCtx(); if (!ctx) return; const t = ctx.currentTime;
    const o = ctx.createOscillator(); o.type = "sine";
    o.frequency.setValueAtTime(880, t); o.frequency.exponentialRampToValueAtTime(560, t + 0.05);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.06, t + 0.008); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.09);
    o.connect(g); g.connect(ctx.destination); o.start(t); o.stop(t + 0.1);
    setTimeout(() => ctx.close().catch(() => {}), 200);
  } catch (e) {}
}
